import { render, staticRenderFns } from "./LocationCard.vue?vue&type=template&id=e59ca6de&scoped=true"
import script from "./LocationCard.vue?vue&type=script&lang=js"
export * from "./LocationCard.vue?vue&type=script&lang=js"
import style0 from "./LocationCard.vue?vue&type=style&index=0&id=e59ca6de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59ca6de",
  null
  
)

export default component.exports